import styled from 'styled-components'
import WrapperComp from 'components/atoms/wrapper'

export const Wrapper = styled(WrapperComp)`
  padding-top: 40px;
  padding-bottom: 40px;
  height: 100%;
  overflow: auto;
`
